import { Column, Icon, Row, Text } from "@amzn/meridian";
import React from "react";
import { useNavigate } from "react-router-dom";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import CompletedInspectionCard from "./completedInspectionCard";
import { useAppSelector } from "src/store/store";

const CompletedInspections = () => {
  const { completedInspections } = useAppSelector((state) => state.inspection);
  const navigate = useNavigate();
  return (
    <div className="app-gradient-bg pwa-scrollable">
      <Column spacingInset="500" spacing="400">
        <Row alignmentVertical="center" spacing="300">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            <Icon tokens={chevronLeftLargeTokens} color="primary" />
          </div>
          <Text type="h200">Dashboard</Text>
        </Row>

        <Text type="b500">Inspection History</Text>

        {completedInspections.length > 0 ? (
          completedInspections.map((inspection) => (
            <CompletedInspectionCard
              key={`${inspection.inspectionId}`}
              inspection={inspection}
            />
          ))
        ) : (
          <Text>You don't have any completed inspections.</Text>
        )}
      </Column>
    </div>
  );
};

export default CompletedInspections;
